import {
  baseResource,
  createResource,
  postResource,
  patchResource,
  deleteResource,
} from '@resource/resource'
import { queryUrlGenerator } from '@utils/friendly'
import { prefixLanguage } from '@utils/urls'
import { prefixAPI } from '@resource/api'
import makeTemplateGetter from '@aspectus/resource-template-url-getter'

const MODEL_PREFIX = 'cabinet'

const orderAdditional = {
  path: [
    'prefix',
    'label',
    'postfix',
    'filters',
  ],
  query: [
    'pagination_offset',
  ],
}

export const formDataFetcher = async (url, formdata, method = 'POST') => {
  const response = await fetch(url, {
    method,
    body: formdata,
    credentials: 'include',
  })

  const text = await response.text()
  return text ? JSON.parse(text) : { code: response.status, data: null }
}

export const COLLECTION_LIST = prefixAPI('/collection/list/', MODEL_PREFIX)
export const COLLECTION_DETAIL = prefixAPI('/collection/{id}/', MODEL_PREFIX)
export const COLLECTION_IMAGE = prefixAPI('/collection/{id}/image/', MODEL_PREFIX)

export const collectionListResource = createResource(COLLECTION_LIST)
export const collectionCreateResource = createResource(COLLECTION_LIST, postResource)

export const collectionDetailResource = createResource(COLLECTION_DETAIL)
export const collectionUpdateResource = createResource(COLLECTION_DETAIL, patchResource)
export const collectionDeleteResource = createResource(COLLECTION_DETAIL, deleteResource)

export const collectionImageDeleteResource = createResource(COLLECTION_IMAGE, deleteResource)
export const collectionImageUploadResource = baseResource
  .url(makeTemplateGetter(COLLECTION_IMAGE))
  .fetcher((url, fd) => formDataFetcher(url, fd, 'POST'))

function getCookie(name) {
  const m = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  return m ? decodeURIComponent(m[2]) : null
}

export async function uploadCollectionImage(id, file, imageAlt = '') {
  const url = COLLECTION_IMAGE.replace('{id}', id)

  const fd = new FormData()
  fd.append('file', file)
  if (imageAlt) fd.append('imageAlt', imageAlt)

  const resp = await fetch(url, {
    method: 'POST',
    body: fd,
    credentials: 'include',
    headers: {
      'X-CSRFToken': getCookie('csrftoken'),
      'X-Requested-With': 'XMLHttpRequest',
    },
  })

  const text = await resp.text()
  const data = text ? JSON.parse(text) : { code: resp.status, data: null }

  if (!resp.ok) {
    throw new Error(text || `Upload failed with ${resp.status}`)
  }

  return data
}
